export const auth0Audience = process.env.REACT_APP_AUTH0_AUDIENCE;
export const AUTH_SESSION_EXPIRED_MESSAGE = "Your session expired. Please log in again.";

export function auth0AccessTokenParams() {
  return {
    authorizationParams: {
      audience: auth0Audience,
    },
  };
}

export function isAuthSessionExpiredError(error) {
  const code = error?.error;
  const description = `${error?.message || ""} ${error?.error_description || ""}`.toLowerCase();
  return (
    code === "missing_refresh_token" ||
    code === "invalid_grant" ||
    description.includes("missing refresh token") ||
    description.includes("invalid refresh token")
  );
}

export async function getAccessTokenOrLogout(getAccessTokenSilently, logout) {
  try {
    return await getAccessTokenSilently(auth0AccessTokenParams());
  } catch (error) {
    if (isAuthSessionExpiredError(error)) {
      logout({
        logoutParams: {
          returnTo: window.location.origin,
        },
      });
      const sessionError = new Error(AUTH_SESSION_EXPIRED_MESSAGE);
      sessionError.displayMessage = AUTH_SESSION_EXPIRED_MESSAGE;
      throw sessionError;
    }
    throw error;
  }
}

export function auth0LoginParams({ screenHint, redirectPath } = {}) {
  return {
    authorizationParams: {
      audience: auth0Audience,
      ...(screenHint ? { screen_hint: screenHint } : {}),
      ...(redirectPath ? { redirect_uri: `${window.location.origin}${redirectPath}` } : {}),
    },
  };
}
